import React, {useEffect, useState} from "react";
import {CardIdentity} from "assets/icons";
import Button from "components/button";
import Importfile from "components/formcomponents/importfile";
import Modalheader from "components/modal/components/header";
import ModalBody from "components/modal/components/body";
import ModalFooter from "components/modal/components/footer";

// The api reads PDF and images alike (Azure prebuilt-read): no conversion before upload.
const ACCEPTED_FILE_TYPES = "image/jpeg,image/jpg,image/png,application/pdf";

const useImagePreviewUrl = (file) => {
    const [previewUrl, setPreviewUrl] = useState(null);
    useEffect(() => {
        if (!file || !String(file.type).startsWith("image/")) {
            setPreviewUrl(null);
            return undefined;
        }
        const url = URL.createObjectURL(file);
        setPreviewUrl(url);
        return () => URL.revokeObjectURL(url);
    }, [file]);
    return previewUrl;
};

const LicencePhotoStep = ({
    translate,
    licenceLabel,
    file,
    onFileChange,
    onRetake,
    isWebcamToUse,
    onToggleWebcam,
    onClose,
    onBack,
    onValidate,
}) => {
    const previewUrl = useImagePreviewUrl(file);

    return (
        <>
            <Modalheader hide={onClose} hideShow={true}>
                {translate("photo_title")}
            </Modalheader>
            <ModalBody>
                <div className="flex flex-col gap-4">
                    <p className="ft-b font-medium text-gray-900">{licenceLabel}</p>
                    {file ? (
                        previewUrl ? (
                            <img
                                src={previewUrl}
                                alt={licenceLabel}
                                className="w-full max-h-[50vh] object-contain rounded-lg bg-gray-100"
                            />
                        ) : (
                            <div className="flex items-center gap-3 p-4 rounded-lg bg-gray-100">
                                <CardIdentity wh={24} color={"#374151"}/>
                                <span className="ft-sm text-gray-700 truncate">{file.name}</span>
                            </div>
                        )
                    ) : (
                        <>
                            <p className="ft-sm text-gray-500">{translate("photo_intro")}</p>
                            <Importfile
                                name={translate("file_label")}
                                titleFile=""
                                webcam={true}
                                setDetectCaptureWebcam={() => {}}
                                accept={ACCEPTED_FILE_TYPES}
                                change={onFileChange}
                            />
                            <button
                                type="button"
                                className="self-start ft-sm text-yellow-500 underline"
                                onClick={onToggleWebcam}
                            >
                                {isWebcamToUse ? translate("import_file") : translate("take_photo")}
                            </button>
                        </>
                    )}
                </div>
            </ModalBody>
            <ModalFooter>
                {file ? (
                    <>
                        <Button size={"LG"} color={"SECONDARY"} onClick={onRetake}>
                            {translate("retake_photo")}
                        </Button>
                        <Button size={"LG"} onClick={onValidate}>
                            {translate("validate_photo")}
                        </Button>
                    </>
                ) : (
                    <Button size={"LG"} color={"SECONDARY"} onClick={onBack}>
                        {translate("back")}
                    </Button>
                )}
            </ModalFooter>
        </>
    );
};

export default LicencePhotoStep;
